import Home from './pages/home/home';
import Video from './components/video';
import QuickView from '@assets/product/quickView';

document.addEventListener('DOMContentLoaded', (e) => {
  new Home().init();
  new Video().init();
  new QuickView().init();
});
